import React from 'react';
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import { FaChevronRight } from 'react-icons/fa6';
import qticketmobileapp from '../../../../assets/img/qticket_mobileapp.webp'
import aljazi from '../../../../assets/img/aljazi.webp'
import digitalsauce from '../../../../assets/img/digital_sauce.webp'

import qticketlogo from '../../../../assets/img/qtickets.webp'
import aljazilogo from '../../../../assets/img/aljazi_logo.webp'
import digitalsaucelogo from '../../../../assets/img/digitalsauce_logo.svg'

import google from '../../../../assets/img/goole_play.webp'
import app from '../../../../assets/img/app_store.webp'
import { Link } from 'react-router-dom';


const SimpleSlider = () => {
  const settings = {
    dots: true,
    arrows: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    fade: true,
    autoplay: true,
    autoplaySpeed: 3000,
    // Optimize slick carousel to reduce forced reflows
    cssEase: 'ease-in-out',
    waitForAnimate: true,
    lazyLoad: 'ondemand',
  };
  const platformdata = [
    {
            logo:aljazilogo,
            tittle:"Wordpress Website",
            desc: "360 Bytes designed and developed a dynamic WordPress website for Al Jazi Real Estate, built to showcase their premium properties with clarity and style. The platform highlights listings, amenities, and updates while ensuring a seamless user experience across all devices.",
            platforms: "Website",
            technology: "WordPress",
            waimg: [],
            img: aljazi,
            path: "https://www.aljazi.com.qa/"
        },
        {
            logo:digitalsaucelogo,
            tittle:"Design and Development",
            desc: "For 360 Digital Sauce, we delivered a complete design and development solution that reflects their bold, creative identity. The result is a visually striking and high-performing platform that enhances brand storytelling and engagement.",
            platforms: "Website",
            technology: "Laravel",
            waimg: [],
            img: digitalsauce,
            path: "https://360-digitalsauce.com/"
        },
        {
            logo:qticketlogo,
            tittle:"Website & Mobile App Development",
            desc: "360 Bytes spearheaded the design, development, and optimization of Q-Tickets’ website and mobile app, powering one of the region’s most trusted online ticketing platforms. The solution combines performance, security, and scalability to handle high traffic and smooth transactions.",
            platforms: "Ios, Android. website",
            technology: ".net core",
            waimg: [google, app],
            img: qticketmobileapp,
            path: "https://q-tickets.com/"
        }
  ]
 return (
    <>
    
      <Slider {...settings}>
        {
          platformdata.map((item, index)=>(
            <div key={index}>
              <div className='hmproject-area'>
                  <div className='hmproject-txt'>
                      <img src={item.logo} alt={item.tittle} loading="lazy" width={200} height={60}/> 
                      <h4>{item.tittle}</h4>
                      <p>{item.desc}</p>
                      <div className='platech'>
                          <div className='platech-sec'>
                            <h5>Platforms</h5> 
                            <h6>{item.platforms}</h6>  
                          </div>
                          <div className='platech-sec'>
                            <h5>Technology</h5> 
                            <h6>{item.technology}</h6>  
                          </div>
                      </div>
                      <div className='plapla'>
                      {item.waimg.map((image, imgIndex) => (
                          <img key={imgIndex} src={image} alt={`App store ${imgIndex}`} width={130} height={40} loading="lazy" />
                        ))}
                        
                      </div>
                      <Link to={item.path} className='btn-main' target='_blank'><span>View</span> <FaChevronRight/></Link>
                  </div> 
                  <div className='hmproject-img'><img src={item.img} alt={item.tittle} width={1200} height={800} loading="lazy"/></div>   
              </div>
            </div>
          ))
        }

      </Slider>
    </>
  );
};

export default SimpleSlider;
